<template>
  <v-app>   
    <Appnav />        
    <v-main >
      <!-- <v-snackbar v-model="snackbar">
        {{ message }}
        <v-btn color="blue" text @click="snackbar = false">
          Close
        </v-btn>
      </v-snackbar> -->
      <v-container fluid class="pa-0">
        <router-view></router-view>
      </v-container>

    </v-main>
  </v-app>
</template>

<script>
import Appnav from './components/Appnav';


export default {
  name: 'App',

  components: {
    Appnav,
  },  
  data: () => ({
    snackbar: false,
    message: '',
  }), 
  mounted() {
  //   this.$messaging.getToken().then(token => {
  //   if (token) {
  //     // User has already granted permission
  //     this.$store.commit('setNotificationEnabled', true);
  //   }
  // }).catch(error => {
  //   console.log(error);
  //   // Handle any errors or set permissions to false as needed
  // });
    // this.requestNotificationPermission();
    // const messaging = this.$firebase.messaging();
    // messaging.requestPermission()
    //   .then(() => {
    //     console.log('Notification permission granted.');
    //     return messaging.getToken()
    //   })
    //   .then((token) => {
    //     console.log(token);  // Display user token
    //   })
    //   .catch((err) => {
    //     console.log('Unable to get permission to notify.', err);
    //   });
    
      // const messaging = this.$firebase.messaging();
    // messaging.onMessage((payload) => {
    //   console.log('Message received. ', payload);
    //   this.message = payload.data.body; // this assumes your payload has a `data.body` property
    //   this.snackbar = true;
      
    //   // Here you can decide what to do with the message.
    //   // For example, show a notification, update the UI, etc.
    // });
    this.initializeFirebaseMessaging();addEventListener
  },
  created() {
    // this.$messaging.onMessage((payload) => {
    //   console.log('Message received. ', payload);
    //   this.$store.dispatch("receiveFcmNotification",payload);
    //   this.showCustomNotification(payload);
    // });
    // this.initializeFirebaseMessaging();addEventListener
  },
  methods: {
    // requestNotificationPermission() {  
    //   // console.log(this.$store.getters.isNotificationEnabled)
    //   if(this.$store.getters.isNotificationEnabled)  {  
    //   this.$messaging.requestPermission()
    //     .then(() => this.$messaging.getToken())
    //     .then((token) => {
    //       console.log('Token:', token);
    //       // Save the token using this.$db
    //       this.$store.dispatch('appNotificationEnabled', true);
    //       this.$store.dispatch("setFcmToken",token);
    //     })
    //     .catch(err => console.error('Permission denied', err));
    //   }else{
    //     console.log("no permission")
    //   }
    // },
    async requestNotificationPermission() {
      if (this.$store.getters.isNotificationEnabled) {
        try {
          await Notification.requestPermission();
          if (Notification.permission === 'granted') {
            const token = await this.$messaging.getToken();
            console.log('Token:', token);
            this.$store.dispatch('appNotificationEnabled', true);
            this.$store.dispatch("setFcmToken", token);
          } else {
            console.log("Notification permission denied");
            this.$store.dispatch('appNotificationEnabled', false);
          }
        } catch (err) {
          console.error('Error requesting permission', err);
          this.$store.dispatch('appNotificationEnabled', false);
        }
      } else {
        console.log("Notifications not enabled in settings");
      }
    },
    // initializeFirebaseMessaging() {
    //   this.$messaging.onMessage((payload) => {
    //   console.log('Message received. ', payload);
    //   this.$store.dispatch("receiveFcmNotification",payload);
    //   // this.showCustomNotification(payload);
    // });
    // },
    async initializeFirebaseMessaging() {
      try {
        if (!window.Notification) return
        // Check if Firebase Messaging is supported
        if (!this.$messaging) {
          console.log('Firebase messaging is not supported');
          return;
        }

        // Check if permission is already granted
        if (Notification.permission === 'granted') {
          // Get the token if permission is already granted
          const token = await this.$messaging.getToken();
          this.$store.dispatch("setFcmToken", token);
        }

        // Set up the message listener
        this.$messaging.onMessage((payload) => {
          console.log('Message received. ', payload);
          this.$store.dispatch("receiveFcmNotification", payload);
          this.showCustomNotification(payload);
        });

        // Handle token refresh
        this.$messaging.onTokenRefresh(async () => {
          try {
            const refreshedToken = await this.$messaging.getToken();
            console.log('Token refreshed');
            this.$store.dispatch("setFcmToken", refreshedToken);
          } catch (err) {
            console.error('Unable to retrieve refreshed token ', err);
          }
        });

      } catch (error) {
        console.error('Error initializing Firebase Messaging:', error);
      }
    },

    showCustomNotification(payload) {
      // Here you can display the notification in your app's UI
      // For example, using a Vue component to show a message
      this.notificationMessage = payload.notification.body;
      // Or use the native Notification API to show a system notification
      if (Notification.permission === 'granted') {
        new Notification(payload.notification.title, {
          body: payload.notification.body,
          icon: payload.notification.icon,
          badge: payload.notification.badge,
        });
      }
    }
  }

};
</script>
